export const volunteerRoutes = [
  {
    path: "/volunteers",
    component: () => import("../../layouts/main/Main"),
    children: [
      {
        path: "management",
        component: () => import("./views/VolunteersManagement"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المتطوعين", active: true },
          ],
          pageTitle: "إدارة المتطوعين",
        },
      },
      {
        path: "achievements",
        component: () => import("./views/AchievementsVolunteers"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إنجازات المتطوعين", active: true },
          ],
          pageTitle: "إنجازات المتطوعين",
        },
      },
      {
        path: "suggestions",
        component: () => import("./views/Suggestions"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "شاركنا أفكارك", active: true },
          ],
          pageTitle: "شاركنا أفكارك",
        },
      },
      {
        path: "availability",
        component: () => import("./views/VolunteerAvailability"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "أيام توفر المتطوعين", active: true },
          ],
          pageTitle: "أيام توفر المتطوعين",
        },
      },
      {
        path: "send-notifications",
        component: () => import("./views/VolunteersSendNotifications"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إرسال الإشعارات المتطوعين", active: true },
          ],
          pageTitle: "إرسال الإشعارات المتطوعين",
        },
      },
      {
        path: "notifications",
        component: () => import("./views/NotificationBatches"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "سجل الإشعارات المرسلة", active: true },
          ],
          pageTitle: "سجل الإشعارات المرسلة",
        },
      },
      {
        path: "notifications/:id/volunteers",
        component: () => import("./views/NotificationBatchVolunteers"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "سجل الإشعارات المرسلة", url: "/volunteers/notifications" },
            { title: "المتلقون", active: true },
          ],
          pageTitle: "المتلقون",
        },
      },
      {
        path: ":id/actions",
        component: () => import("./views/VolunteerActions"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المتطوعين", url: "/volunteers/management" },
            { title: "مشاركات زادي", active: true },
          ],
          pageTitle: "مشاركات زادي",
        },
      },
      {
        path: "tasks",
        component: () => import("./views/Tasks"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المتطوعين", url: "/volunteers/management" },
            { title: "فرص التطوع", active: true },
          ],
          pageTitle: "فرص التطوع",
        },
      },
      {
        path: "tasks/:id/sessions",
        component: () => import("./views/TaskSessions"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المتطوعين", url: "/volunteers/management" },
            { title: "فرص التطوع", url: "/volunteers/tasks" },
            { title: "جلسات التطوع", active: true },
          ],
          pageTitle: "جلسات التطوع",
        },
      },
      {
        path: "tasks/:id/sessions/:sessionId/applied",
        component: () => import("./views/TaskSessionsAppliedVolunteers"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المتطوعين", url: "/volunteers/management" },
            { title: "فرص التطوع", url: "/volunteers/tasks" },
            { title: "المتطوعين المتقدمين", active: true },
          ],
          pageTitle: "المتطوعين المتقدمين",
        },
      },
      {
        path: "tasks/:id/sessions/:sessionId/close",
        component: () => import("./views/CloseTaskSession"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المتطوعين", url: "/volunteers/management" },
            { title: "فرص التطوع", url: "/volunteers/tasks" },
            { title: "المتطوعين المتقدمين", active: true },
          ],
          pageTitle: "المتطوعين المتقدمين",
        },
      },
      {
        path: "tasks/add",
        component: () => import("./views/TaskForm"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المتطوعين", url: "/volunteers/management" },
            { title: "فرص التطوع", url: "/volunteers/tasks" },
            { title: "إضافة فرصة تطوع", active: true },
          ],
          pageTitle: "إضافة فرصة تطوع",
        },
      },
      {
        path: "tasks/:id/edit",
        component: () => import("./views/TaskForm"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المتطوعين", url: "/volunteers/management" },
            { title: "فرص التطوع", url: "/volunteers/tasks" },
            { title: "تعديل فرصة تطوع", active: true },
          ],
          pageTitle: "تعديل فرصة تطوع",
        },
      },
      {
        path: "tasks/:id/duplicate",
        component: () => import("./views/TaskForm"),
        meta: {
          isDuplicate: true,
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المتطوعين", url: "/volunteers/management" },
            { title: "فرص التطوع", url: "/volunteers/tasks" },
            { title: "تكرار فرصة تطوع", active: true },
          ],
          pageTitle: "تكرار فرصة تطوع",
        },
      },
      {
        path: "tasks/:id/volunteers",
        component: () => import("./views/TaskVolunteers"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المتطوعين", url: "/volunteers/management" },
            { title: "فرص التطوع", url: "/volunteers/tasks" },
            { title: "المتطوعين", active: true },
          ],
          pageTitle: "المتطوعين",
        },
      },
      {
        path: "tasks/:id/assign",
        component: () => import("./views/TaskAssigner"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المتطوعين", url: "/volunteers/management" },
            { title: "فرص التطوع", url: "/volunteers/tasks" },
            { title: "إسناد المتطوعين", active: true },
          ],
          pageTitle: "إسناد المتطوعين",
        },
      },
      {
        path: "tasks/archived",
        component: () => import("./views/ArchivedTasks"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المتطوعين", url: "/volunteers/management" },
            { title: "الفرص المؤرشفة", active: true },
          ],
        pageTitle: "الفرص المؤرشفة",
        },
      },
      {
        path: "courses",
        component: () => import("./views/courses/Index.vue"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المتطوعين", url: "/volunteers/management" },
            { title: "الفرص التدريبية", active: true },
          ],
          pageTitle: "الفرص التدريبية",
        },
      },
      {
        path: "courses/:id/assign",
        component: () => import("./views/courses/CourseAssigner"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المتطوعين", url: "/volunteers/management" },
            { title: "الفرص التدريبية", url: "/volunteers/courses" },
            { title: "إسناد المتطوعين", active: true },
          ],
          pageTitle: "إسناد المتطوعين",
        },
      },
      {
        path: "courses/:id/volunteers",
        component: () => import("./views/courses/CourseVolunteers"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المتطوعين", url: "/volunteers/management" },
            { title: "الفرص التدريبية", url: "/volunteers/courses" },
            { title: "المتطوعين", active: true },
          ],
          pageTitle: "المتطوعين",
        },
      },
      {
        path: "courses/archived",
        component: () => import("./views/ArchivedCourses"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المتطوعين", url: "/volunteers/management" },
            { title: "الفرص التدريبية المؤرشفة", active: true },
          ],
        pageTitle: "الفرص التدريبية المؤرشفة",
        },
      },
      {
        path: "zadi-sessions",
        component: () => import("./views/zadi-sessions/Index.vue"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المتطوعين", url: "/volunteers/management" },
            { title: "جلسات زادي", active: true },
          ],
          pageTitle: "جلسات زادي",
        },
      },
      {
        path: "zadi-sessions/:id/publish",
        component: () => import("./views/zadi-sessions/ZadiSessionPublisher"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المتطوعين", url: "/volunteers/management" },
            { title: "جلسات زادي", url: "/volunteers/zadi-sessions" },
            { title: "نشر الجلسة", active: true },
          ],
          pageTitle: "نشر الجلسة",
        },
      },
      {
        path: "zadi-sessions/:id/check-ins",
        component: () => import("./views/zadi-sessions/ZadiSessionCheckIns"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المتطوعين", url: "/volunteers/management" },
            { title: "جلسات زادي", url: "/volunteers/zadi-sessions" },
            { title: "سجل الحضور", active: true },
          ],
          pageTitle: "سجل الحضور",
        },
      },
      {
        path: "zadi-sessions/:id/add-volunteers",
        component: () => import("./views/zadi-sessions/ZadiSessionAddVolunteers"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المتطوعين", url: "/volunteers/management" },
            { title: "جلسات زادي", url: "/volunteers/zadi-sessions" },
            { title: "إضافة متطوعين", active: true },
          ],
          pageTitle: "إضافة متطوعين",
        },
      },
      {
        path: "zadi-sessions/:id/volunteers",
        component: () => import("./views/zadi-sessions/ZadiSessionVolunteers"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المتطوعين", url: "/volunteers/management" },
            { title: "جلسات زادي", url: "/volunteers/zadi-sessions" },
            { title: "المتطوعين المضافين", active: true },
          ],
          pageTitle: "المتطوعين المضافين",
        },
      },
      {
        path: "zadi-sessions/archived",
        component: () => import("./views/zadi-sessions/ArchivedZadiSessions"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المتطوعين", url: "/volunteers/management" },
            { title: "جلسات زادي المؤرشفة", active: true },
          ],
          pageTitle: "جلسات زادي المؤرشفة",
        },
      },
      {
        path: "thank-you-messages",
        component: () => import("./views/ThankYouMessages.vue"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المتطوعين", url: "/volunteers/management" },
            { title: "رسائل الشكر", active: true },
          ],
          pageTitle: "رسائل الشكر",
        },
      },
      {
        path: "supervisors",
        component: () => import("./views/SupervisorsManagement"),
        meta: {
          breadcrumb: [
            { title: "Home", url: "/" },
            { title: "إدارة المشرفين", active: true },
          ],
          pageTitle: "إدارة المشرفين",
        }
      },
    ],
  },
];
